import { render, staticRenderFns } from "./ApprenticeshipView.vue?vue&type=template&id=020f3e75"
import script from "./ApprenticeshipView.vue?vue&type=script&lang=js"
export * from "./ApprenticeshipView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports